module.exports = __webpack_public_path__ + "img/11.f045af7a.png";